import moment from 'moment';

import { IReportWithoutCustomFields, IReport, IReportWithFlattenedCustomFields } from '../common/model/report.model';
import { IReportCustomFields } from '../common/model/reportCustomFields.model';
//import { ReportStatus } from '../common/model/enumerations/reportStatus.model';

const initDatesCommon = (report: IReportWithoutCustomFields): IReportWithoutCustomFields => {
  return {
    ...report,
    reference: report.reference ? report.reference.split(',').filter((r) => r.trim().length > 0).join(',') : report.reference,
    entryDate: report.entryDate ? moment(report.entryDate) : report.entryDate,
    expectedDate: report.expectedDate ? moment(report.expectedDate) : report.expectedDate,
    endDate: report.endDate ? moment(report.endDate) : report.endDate,
    expirationDate: report.expirationDate ? moment(report.expirationDate) : report.expirationDate,
    advanceDate: report.advanceDate ? moment(report.advanceDate) : report.advanceDate
  };
};

export const initDates = (report: IReport): IReport => {
  let customFields: IReportCustomFields = null;
  if (report.customFields) {
    customFields = {
      ...report.customFields,
      qualityControlDate: report.customFields.qualityControlDate ? moment(report.customFields.qualityControlDate) : report.customFields.qualityControlDate,
      buyerDate: report.customFields.buyerDate ? moment(report.customFields.buyerDate) : report.customFields.buyerDate,
      validationDate: report.customFields.validationDate ? moment(report.customFields.validationDate) : report.customFields.validationDate
    };
  }
  return {
    ...initDatesCommon(report),
    customFields
  };
};

export const initDatesFlattened = (report: IReportWithFlattenedCustomFields): IReportWithFlattenedCustomFields => {
  return {
    ...report,
    ...initDatesCommon(report),
    qualityControlDate: report.qualityControlDate ? moment(report.qualityControlDate) : report.qualityControlDate,
    buyerDate: report.buyerDate ? moment(report.buyerDate) : report.buyerDate,
    validationDate: report.validationDate ? moment(report.validationDate) : report.validationDate
  };
};

export const canRequestAdvance = (report: IReport | IReportWithFlattenedCustomFields): boolean => {
  return report.canRequestAdvance;
};
